module.exports = __webpack_public_path__ + "img/wedss8.61ea7510.jpg";